<section *ngIf="!isOnAnalysis && !isOnAi && !isOnManipulation" class="originality_score"
  [class.side-bar-collapsed]="sideBarCollapsed">
  <section *ngIf="!sideBarCollapsed" class="title">
    <h1 [ariaLabel]="['Originality index is: ' + (displayValue ? displayValue : 'N/A')]">
      {{ 'new_entries.originality_index' | translate }}
      <span class="status_tag" [ngClass]="{
        'high_risk': percentage >= highRiskThreshold && displayValue !== 'N/A',
        'medium_risk': percentage >= mediumRiskThreshold && percentage < highRiskThreshold && displayValue !== 'N/A',
        'low_risk': percentage < mediumRiskThreshold && displayValue !== 'N/A',
        'none_risk': displayValue === 'N/A'
      }" [ngStyle]="{ background: backgroundColor }">
        <span class="status_tag_circle"></span>
        <span class="status_tag_label">
          {{ displayValue }}
        </span>
      </span>
    </h1>
    <button
      (click)="openLink('https://support.inspera.com/hc/en-us/articles/27520989957917-Originality-Report-Index')">{{
      'new_entries.learn_more' | translate }}</button>
  </section>
  <section class="index_score" [ngStyle]="{ background: backgroundColor }" focusable>
    <div class="alert_img">
      <img [src]="[indexImage]" alt="" />
    </div>
    <section *ngIf="!sideBarCollapsed" class="originality_label">
      <p>
        <span class="score-bold bold">{{ displayValue }}</span>
        {{ warningText }}
      </p>
    </section>
  </section>
</section>
